import firebase from "firebase/app";
import firebaseConfig from './config';
import "firebase/firestore";

firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();

export { db };
export default firebase;
